Vendd.Scripts.load(function () {

    var Vendd = window.Vendd || {};

    var containerControlBase = function (element, definition) {

        Vendd.inlineEdit.controlBase.apply(this, [element, definition]);

        this.controls = [];
    };
    containerControlBase.prototype = Object.create(Vendd.inlineEdit.controlBase.prototype);
    containerControlBase.prototype.name = 'containerControlBase';

    containerControlBase.prototype.build = function () {

        var self = this;

        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.controlBase.prototype.build.apply(self); })
            .then(function() { return Q.all(self.controls.map(function(x) { return Vendd.Promises.GetOrDefault(function() { return x.build(); }); })); });

    };

    containerControlBase.prototype.render = function () {

        var self = this;

        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.controlBase.prototype.render.apply(self); })
            .then(function() { return Q.all(self.controls.map(function(x) { return Vendd.Promises.GetOrDefault(function() { return x.render(); }); })); });

    };

    containerControlBase.prototype.bind = function () {

        var self = this;

        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.controlBase.prototype.bind.apply(self); })
            .then(function() { return Q.all(self.controls.map(function(x) { return Vendd.Promises.GetOrDefault(function() { return x.bind(); }); })); });

    };

    Vendd.inlineEdit.controls = {}
    Vendd.inlineEdit.containerControlBase = containerControlBase;

});